var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ks-is-fullwidth"},[(_vm.hasComment)?[_c('kst-divider',{staticClass:"has-background-black"}),_c('kst-value',{staticClass:"is-size-5",attrs:{"field":"Comment","data":_vm.details,"catalog":_vm.Catalog}}),_c('kst-divider',{staticClass:"has-background-black"})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }